/**
 * Pending Withdraw Item View
 */

define(function(require, exports, module) {
    'use strict';

    var BaseView = require('common/base.view');
    var Form = require('class/form.class');

    module.exports = BaseView.extend({

        events: {
            'submit .fn-form-cancel': 'handleCancelWithdraw'
        },

        render: function() {
            var modelData = this.model.toJSON();

            if (modelData.method.code === 'BankTransferCH') {
                this._bankTransferCHHack(modelData);
            }

            this.setElement(this.tmpl('pending.item', modelData));

            this.form = new Form(this.$('.fn-form-cancel'));

            return this;
        },

        _bankTransferCHHack: function(modelData) {
            var accountIdValue = modelData.method.account[0].specificParams.field1;
            modelData.method.account[0].specificParams.accountId =
                '*' + accountIdValue.substr(accountIdValue.length - 4);
        },

        handleCancelWithdraw: function(e) {
            e.preventDefault();

            this.form.showLoading();

            this.model.destroy({ wait: true })
                .always(this.form.hideLoading.bind(this.form))
                .done(this.cancelWithdrawSuccess.bind(this))
                .fail(this.cancelWithdrawFail.bind(this));
        },

        cancelWithdrawSuccess: function() {
            this.showInfo({
                content: this.translate('playtech.mobile.system.mobile-cashier.pending-withdraw.cancelAction.success')
            });

            this.close();
        },

        cancelWithdrawFail: function(model, response) {
            this.showInfo({
                content: response.data.errorMessage || 'System Error'
            });
        }
    });
});
